import { OktaAuth } from '@okta/okta-auth-js';

import routes from '@/routes/config';

const ISSUER = import.meta.env.VITE_OKTA_AUTH_ISSUER;
const CLIENT_ID = import.meta.env.VITE_OKTA_AUTH_CLIENT_ID;
const BASE_URL = import.meta.env.VITE_APP_BASE_URL;

const memoryStore: Record<string, string> = {};

const oktaAuth = new OktaAuth({
  issuer: ISSUER,
  clientId: CLIENT_ID,
  redirectUri: `${BASE_URL}${routes.login.callback}`,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
  responseType: ['token', 'id_token'],
  tokenManager: {
    autoRenew: true,
    storageProvider: {
      getItem: (key: string) => {
        if (key.includes('refresh')) return localStorage.getItem(key);
        return memoryStore[key] ?? null;
      },
      setItem: (key: string, val: string) => {
        if (key.includes('refresh')) localStorage.setItem(key, val);
        else memoryStore[key] = val;
      },
      removeItem: (key: string) => {
        localStorage.removeItem(key);
        delete memoryStore[key];
      }
    }
  } as any
});

export default oktaAuth;